import { memo } from "react";
import { createSelectable } from "react-selectable-fast";

import { Box } from "@mui/material";
import PropTypes from "prop-types";

function Selectable({ selectableRef, isSelecting, place, day }) {
  return (
    <Box
      sx={(theme) => ({
        width: 1,
        height: 10.25,
        "&:hover": {
          backgroundColor: "rgba(255,255,255,.1)",
          ...theme.applyStyles("light", {
            backgroundColor: "rgba(0,0,0,.1)",
          }),
        },
        ...(isSelecting && {
          backgroundColor: "rgba(255,255,255,.1)",
          ...theme.applyStyles("light", {
            backgroundColor: "rgba(0,0,0,.1)",
          }),
        }),
      })}
      ref={selectableRef}
      id={`quart-${day}-${place}`}
    />
  );
}

Selectable.propTypes = {
  selectableRef: PropTypes.func,
  isSelecting: PropTypes.bool,
  place: PropTypes.number,
  day: PropTypes.string,
};

export default memo(createSelectable(Selectable));
